import Page from "webPage/Page";
import TrainingFilters from "util/TrainingFilters";

Page.register("tax-training-category", () => {

    let $courses = $('.js-courses');
    if ($courses.length > 0) {
        $courses.each(function () {
            new TrainingFilters($courses);
        });
    }

    $('body').on('click', '.js-training', function () {
        let url = $(this).attr('href');
        try {
            dataLayer.push({
                'event': 'training-click',
                'course-url': url,
                'eventCallback': function () {
                    window.location.href = url;
                }
            });
        } catch (e) {
            console.log(e);
            window.location.href = url;
        }
        return false;
    });
});